import { useMutation, useQueryClient } from "@tanstack/react-query";

import useGetAccessToken from "components/Login/useGetAccessToken";
import type { ChatThread } from "types/ChatThread";
import { patchThread, type PatchThreadInput } from "../methods/patchThread";

interface PatchThreadVariables {
  threadId: string;
  patch: PatchThreadInput;
}

/**
 * Patches a chat thread's metadata and updates the cached threads list in place.
 */
export default function usePatchThreadMutation() {
  const getAccessToken = useGetAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ threadId, patch }: PatchThreadVariables) =>
      patchThread(threadId, patch, getAccessToken),
    onSuccess: (data) => {
      // Replace the updated thread in the cached list directly. Avoiding
      // invalidate so a metadata edit doesn't trigger an extra GET /threads
      // while the user is mid-flow.
      queryClient.setQueryData<ChatThread[]>(["cc-db-api", "threads"], (prev) =>
        prev?.map((t) => (t.id === data.id ? data : t))
      );
    },
  });
}
